import React, { useState } from "react";
import Navbar from "./Reusable/Navbar"; 
import Footer from "./Reusable/Footer"; 
import { HelmetProvider } from "react-helmet-async";
import { MdPhoneInTalk } from "react-icons/md";
const Layout = ({ children }) => {
  const [showHotline, setShowHotline] = useState(false)
	const helmetContext = {};
	
  return (
		<HelmetProvider context={helmetContext}>
			<div className='lg:min-h-screen font-sans relative'>
				{/* Navbar */}
				<Navbar />
				{/* Main Content */}
				<main className='flex-grow'>{children}</main>
				{/* Footer */}
				<Footer />

				<div className='fixed bottom-4 right-4'>
					<button
						onClick={() => setShowHotline(!showHotline)}
						onMouseEnter={() => setShowHotline(true)}
						className='md:p-5 p-3 rounded-[100px] bg-[#83f9c0]'>
						<MdPhoneInTalk color='#0F713E' size={20} />
					</button>

					{showHotline && (
						<p className='text-[#0F713E] text-base/6 font-medium py-3 px-3.5 bg-[#83f9c0] rounded-[68px] fixed lg:right-20 right-16 lg:bottom-5 bottom-4'>
							Call our hotline: <a href='tel:(888) 416-6573' className="hover:underline">(888) 416-6573</a>
						</p>
					)}
				</div>
			</div>
		</HelmetProvider>
	);
};

export default Layout;
